import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
} from '@mui/material';
import { themeColors } from '@styles/theme';
import { useTheme } from '@context/themeContext';

type DialogComponentProps = {
    onCloseFn: (event: any, reason?: 'backdropClick' | 'escapeKeyDown') => void;
    dialogTitle: string;
    children?: React.ReactNode;
} & DialogProps;

const DialogComponent = ({
    onCloseFn,
    dialogTitle = '',
    children,
    ...restProps
}: DialogComponentProps) => {
    const { theme } = useTheme();
    const { t } = useTranslation();

    const backgroundColor = theme === 'light' ? themeColors.white : themeColors.grey4;
    const color = theme === 'light' ? themeColors.navyBlue : themeColors.white;

    return (
        <Dialog
            {...restProps}
            onClose={onCloseFn}
            className="MuiDialog-root"
            slotProps={{
                paper: {
                    sx: {
                        color,
                        backgroundColor,
                        minWidth: '400px',
                    },
                },
            }}
        >
            <DialogTitle sx={{}}>{dialogTitle}</DialogTitle>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button onClick={onCloseFn}>{t('action-menu.dialog-cancel-btn')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogComponent;
